import { Switch, Route } from 'react-router-dom';
import { path } from '../utils/const';

import Landing from '../pages/landing';

const OutShopRoute = () => {
  return (
    <Switch>
      <Route path={path.creators} component={Landing} />
    </Switch>
  );
};

export default OutShopRoute;
